<template>
  <div id="page">
    <Header />

    <div class="section" id="cta">
      <div class="left">
        <h1>Rebar Data</h1>
        <p>Explore Rebar's existing community of data, derive new features, or bring your own data</p>
        <router-link tag="button" to="/data/browse">Get Started</router-link>
      </div>
      <div class="right spinner">
        <span>Economics</span>
        <span>Marketing</span>
        <span>Stocks</span>
        <span>Product Analytics</span>
        <span>Weather</span>
      </div>
    </div>

    <div class="section" id="data">
      <div class="left" id="data-left">
        <img src="@/assets/images/Predefined Data.svg" width="85%" />
      </div>
      <div class="right">
        <h3>Leverage existing data series</h3>
        <p>Explore the facts with our prepared data or use them
           to jump right into modeling and forecasting</p>
      </div>
    </div>

    <div class="section" id="versions">
      <div class="left">
        <h3>Compare different versions of the data</h3>
        <p>Data is complex, so compare different versions and adjustments
           to find the right one for your situation</p>
      </div>
      <div class="right">
        <svg id="spark-lines" viewBox="0 0 300 150" style="max-width: 300px; max-height: 150px;">
          <g transform="translate(0,25)">
            <line x1="60" x2="60" y1="-20" y2="20" stroke="black" />
            <text>Original</text>
            <path :d= "lineGenerator(originalData)" class="new-line"></path>
          </g>

          <g transform="translate(0,75)">
            <line x1="60" x2="60" y1="-20" y2="20" stroke="black" />
            <text transform="translate(0,-7)">Reporting</text>
            <text transform="translate(0,7)">Change</text>
            <path :d= "lineGenerator(originalData)" class="old-line"></path>
            <path :d= "lineGenerator(changedData)" class="new-line"></path>
          </g>

          <g transform="translate(0,125)">
            <line x1="60" x2="60" y1="-20" y2="20" stroke="black" />
            <text transform="translate(0,-7)">Seasonally</text>
            <text transform="translate(0,7)">Adjusted</text>
            <path :d= "lineGenerator(changedData)" class="old-line"></path>
            <path :d= "lineGenerator(adjustedData)" class="new-line"></path>
          </g>
        </svg>
      </div>
    </div>

    <div class="section" id="structure">
      <div class="left">
        <img src="@/assets/images/Data Collaboration.svg" width="75%" />
      </div>
      <div class="right">
        <h3>Discuss, share, and improve</h3>
        <p>Collaborate to analayze, understand, and share data
           insights anywhere across the web</p>
      </div>
    </div>

    <div class="section">
      <EmailCollection />
    </div>
    
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import EmailCollection from '@/components/layout/EmailCollection';

const d3 = require('d3');

let xAxis = d3.scaleLinear().domain([0,20]).range([60,300]);
let yAxis = d3.scaleLinear().domain([-1,1]).range([20, -20]);
let line = d3.line().x(d => xAxis(d.x)).y(d => yAxis(d.y));

// Create fake data to show on the landing page
let originalData = [...Array(20).keys()].map(d => ({
  'x': d,
  'y': (Math.random()-.5)/2 + (d < 10 ? 0 : -.5) + (d%3 === 0) * .5
}));
let changedData = originalData.map(d => ({
  'x': d.x,
  'y': d.y + (d.x < 10 ? 0 : +.5)
}));
let adjustedData = changedData.map(d => ({
  'x': d.x,
  'y': d.y + (d.x%3 === 0) * -.5
}));


export default {
  name: 'DataHome',
  components: {
    Header,
    Footer,
    EmailCollection
  },
  data: function() {
    return {
      originalData: originalData,
      changedData: changedData,
      adjustedData: adjustedData,
      lineGenerator: line
    }
  }
}
</script>

<style scoped>
#spark-lines {
  font-size: .7em;
}
.new-line {
  fill: none;
  stroke: black;
}
.old-line {
  fill: none;
  stroke: #c0ccd7;
  stroke-dasharray: 3 2;
}

.spinner {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 1.2em;
}
.spinner > span:nth-child(1) { color: #3181c1; }
.spinner > span:nth-child(2) { color: #80b3dc; }
.spinner > span:nth-child(3) { color: #ffffff; }
.spinner > span:nth-child(4) { color: #80b3dc; }
.spinner > span:nth-child(5) { color: #3181c1; }

button {
  font-size: 1em;
  background-color: #00bc83;
  border: solid 1px black;
  border-radius: 3px;
}

#page {
  display: flex;
  flex-direction: column;
  font-size: 1em;
}

#cta {
  padding: 1% 0 3% 0;
  border-bottom: solid 1px #000000;
  background-color: #0666B4;
  color: #ffffff;
}

#email {
  width: 100%;
}

#data {
  margin-top: 20px;
}

.section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  width: 100%;
  min-height: 200px;
}
.section p {
  width: 75%;
  margin-left: auto;
  margin-right: auto;
}

.left {
  width: 100%;
  padding-left: 5%;
}
.right {
  width: 100%;
  padding-right: 5%;
}

@media only screen and (max-width: 600px) {
  .section {
    flex-direction: column;
    padding: 40px 0 0 0;
  }
  #versions {
    flex-direction: column-reverse;
  }
  .left, .right {
    padding: 0;
  }
  .spinner {
    padding: 1em 0;
  }
}
</style>